import React from 'react';
import { ViewModel } from '../../../controller/viewModel/viewModel';
import { classes, st } from './ServiceCard.st.css';
import { Card } from '@wix/wix-ui-tpa/cssVars';
import { ServiceImage } from './ServiceImage/ServiceImage';
import { DataHooks, DEFAULT_IMAGE_CONTAINER } from './consts';
import { ServiceInfo } from './ServiceInfo/ServiceInfo';

export const ServiceCard: React.FC<{
  service: ViewModel['bodyViewModel']['services'][number];
}> = ({ service }) => {
  const { width, height } = DEFAULT_IMAGE_CONTAINER;

  return (
    <Card
      className={st(classes.root, { even: true })}
      data-hook={DataHooks.CARD}
    >
      <Card.Container className={classes.media} data-hook={DataHooks.IMAGE}>
        <ServiceImage
          image={service.image}
          imageTitle={service.name}
          width={width}
          height={height}
          onClick={() => {}}
        />
      </Card.Container>
      <Card.Container data-hook={DataHooks.INFO} className={classes.info}>
        <ServiceInfo service={service} />
      </Card.Container>
    </Card>
  );
};
